"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateDefaultFieldState = void 0;

var _immutable = require("immutable");

var _resolveInitialFieldValue = require("./resolveInitialFieldValue");

var _resolveLabel = require("./resolveLabel");

/**
 *
 * @param field {import('../useForm').IFormFieldArgs}
 * @param {*} initialValues
 * @param options {import('../useForm').IFormOptions}
 */
var generateDefaultFieldState = function generateDefaultFieldState(field, initialValues, options) {
  if (!field.name) throw new Error('name is required on field');
  var label = (0, _resolveLabel.resolveLabel)(field, options);
  var value = (0, _resolveInitialFieldValue.resolveInitialFieldValue)(field.value, initialValues.getIn(field.name.split('.')), field.type);
  return (0, _immutable.fromJS)({
    initial: {
      type: field.type || 'text',
      optional: field.optional || false,
      label: label
    },
    current: {
      helperText: field.helperText || '',
      error: false,
      pristine: true,
      touched: false
    }
  }).setIn(['initial', 'field'], field).setIn(['initial', 'value'], value).setIn(['current', 'value'], value);
};

exports.generateDefaultFieldState = generateDefaultFieldState;